module.exports = __webpack_public_path__ + "static/media/icon-info.0b4ef834.svg";